<div class="left-bar bar"></div>
<span class="history-text">{{formattedDate}}</span>
<div class="right-bar bar"></div>
